// extracted by mini-css-extract-plugin
module.exports = {"scrollHidden":"Catalog_scrollHidden__Pcd0_","menuContainer":"Catalog_menuContainer__Sx_Ci"};